import { useTheme } from "@mui/material";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";

import { formatIsoDateString } from "../../utils/helpers";

const EmpireKPIValueListItem = props => {
  const { kpiValueODM, index, upper, lower, kpiName } = props;
  const theme = useTheme();

  const getStoplightColor = (value, upper, lower) => {
    if (lower === 0) {
      if (value > 0) {
        return "#f44336";
      } else {
        return "#F5C336";
      }
    }
    if (value >= upper) {
      return "#3d9461";
    }
    if (value <= lower) {
      return "#f44336";
    }
    return "#F5C336";
  };

  return (
    <ListItem
      disableGutters={true}
      sx={{
        padding: theme.spacing(1),
        paddingTop: 0,
        paddingBottom: 0,
        marginBottom: theme.spacing(1),
        borderRadius: theme.spacing(1),
        backgroundColor: getStoplightColor(kpiValueODM.kpiValue, upper, lower),
        color: theme.palette.info.contrastText,
        cursor: "pointer",
        boxShadow: theme.shadows[3],
        userSelect: "none",
        webkitUserSelect: "none",
      }}
      onClick={e => {
        e.stopPropagation();
        // if (onClickHandler) {
        //   onClickHandler(kpiValueODM.value);
        // }
      }}
    >
      <ListItemText
        primary={
          <Typography
            variant="h6"
            sx={{
              display: "flex",
              flexDirection: "column",
              marginLeft: theme.spacing(1),
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              color: theme.palette.info.contrastText,
              marginTop: 0,
            }}
          >
            {`${kpiName}: ${kpiValueODM.kpiValue}`}
          </Typography>
        }
        secondary={
          <Typography
            variant="body2"
            sx={{
              display: "flex",
              flexDirection: "row",
              marginLeft: theme.spacing(1),
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              marginTop: "-6px",
              color: theme.palette.info.contrastText,
              minimumHeight: 20,
            }}
          >
            {`Week ${index}, ${formatIsoDateString(kpiValueODM.dateOfEntry)}`}
          </Typography>
        }
      />
    </ListItem>
  );
};

export default EmpireKPIValueListItem;
